import React, { useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  CheckBox,
  FormHeader,
  PreviewAdsImage,
} from "../../../components";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PayPalCheckout from "../payPalPaymentComponent";

const StartNewAdCampaign = (props) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const [scheduleTime, setScheduleTime] = useState({
    sevenDays: false,
    thirtyDays: false,
    oneTwentyEightDays: false,
  });
  const [continuous, setContinuous] = useState(false);
  const [cardFieldsForm, setCardFieldsFrom] = useState("");

  const { advertisement } = useSelector(
    ({ adsCampaignReducer }) => adsCampaignReducer
  );

  const onChangePayment = (fields) => {
    setCardFieldsFrom(fields);
  };

  return (
    <>
      <div className=" d-flex flex-row justify-content-between ">
        <div
          className="col-12 ats-body-left-wrapper"
          style={{ width: "100%", height: "100%" }}
        >
          <div className={"ats__title"}>Set Campaign Duration & Budget</div>
          <div className={"ats__subtitle"}>
            Choose where the ad will appear across the platform
          </div>
          <div className="d-flex flex-row flex-wrap" style={{ gap: "12px" }}>
            <CheckBox
              data={{
                checkName: "7 days",
                isActive: scheduleTime.sevenDays,
              }}
              onClick={() => {
                setScheduleTime((prev) => ({
                  sevenDays: !prev.sevenDays,
                  thirtyDays: false,
                  oneTwentyEightDays: false,
                }));
                setContinuous(false);
              }}
            />

            <CheckBox
              data={{
                checkName: "30 days",
                isActive: scheduleTime.thirtyDays,
              }}
              onClick={() => {
                setScheduleTime((prev) => ({
                  sevenDays: false,
                  thirtyDays: !prev.thirtyDays,
                  oneTwentyEightDays: false,
                }));
                setContinuous(false);
              }}
            />
            <CheckBox
              data={{
                checkName: "128 days",
                isActive: scheduleTime.oneTwentyEightDays,
              }}
              onClick={() => {
                setScheduleTime((prev) => ({
                  sevenDays: false,
                  thirtyDays: false,
                  oneTwentyEightDays: !prev.oneTwentyEightDays,
                }));
                setContinuous(false);
              }}
            />
            <CheckBox
              data={{
                checkName: "Run Continuously Until Paused",
                isActive: continuous,
              }}
              onClick={() => {
                setContinuous(!continuous);
                setScheduleTime({
                  sevenDays: false,
                  thirtyDays: false,
                  oneTwentyEightDays: false,
                });
              }}
            />
          </div>

          <div className={"ats__title mt-4 mb-4"}>Payment method</div>
          <FormHeader
            data={{
              formHeader: scheduleTime?.sevenDays ? (
                <>{"USD 8.25"}</>
              ) : scheduleTime?.thirtyDays ? (
                <>{"USD 33.00"}</>
              ) : scheduleTime?.oneTwentyEightDays ? (
                <>{"USD 115.49"}</>
              ) : continuous ? (
                <>{"USD 181.49"}</>
              ) : (
                ""
              ),
              size: "md-sm",
            }}
          />
          <PayPalCheckout
            paymentData={{
              currency_type: "USD",
              amount: scheduleTime?.sevenDays
                ? 8.25
                : scheduleTime?.thirtyDays
                ? 33.0
                : scheduleTime?.oneTwentyEightDays
                ? 115.49
                : continuous
                ? 181.49
                : 0,
            }}
          />
        </div>
        <div className="ats-body-right-wrapper">
          <div className="aiw-title">Preview</div>
          {advertisement?.ad_space?.header &&
            (advertisement?.header_banner_img?.length > 0 ||
              advertisement?.header_gif?.length > 0) && (
              <PreviewAdsImage
                data={{ type: "header" }}
                imageList={[
                  ...advertisement?.header_banner_img,
                  ...advertisement?.header_gif,
                ]}
              />
            )}
          {advertisement?.ad_space?.right &&
            (advertisement?.right_banner_img?.length > 0 ||
              advertisement?.right_gif?.length > 0) && (
              <PreviewAdsImage
                data={{ type: "slider" }}
                imageListRight={[
                  ...advertisement?.right_banner_img,
                  ...advertisement?.right_gif,
                ]}
              />
            )}
          {advertisement?.text_banner_img?.length > 0 && (
            <PreviewAdsImage
              data={{ type: "banner" }}
              logo={advertisement?.text_banner_logo}
              banner={advertisement?.text_banner_img?.[0]}
              title={advertisement?.title}
              content={advertisement?.description}
              btnType={advertisement?.button_type}
            />
          )}
        </div>
      </div>
      {/* <Button
        data={{
          btnName: scheduleTime?.sevenDays ? (
            <>
              <div>{"Rs.2,500.00"}</div>
              <div>{"Pay and publish"}</div>
            </>
          ) : scheduleTime?.thirtyDays ? (
            <>
              <div>{"Rs.10,000.00"}</div>
              <div>{"Pay and publish"}</div>
            </>
          ) : scheduleTime?.oneTwentyEightDays ? (
            <>
              <div>{"Rs.35,000.00"}</div>
              <div>{"Pay and publish"}</div>
            </>
          ) : continuous ? (
            <>
              <div>{"Rs.55,000.00"}</div>
              <div>{"Pay and publish"}</div>
            </>
          ) : (
            "Next"
          ),
          buttonType:
            scheduleTime.sevenDays ||
            scheduleTime.thirtyDays ||
            scheduleTime.oneTwentyEightDays ||
            continuous
              ? "primary"
              : "primary disabled",
          buttonSize: "lg",
          innerStyle: scheduleTime?.sevenDays
            ? " d-flex flex-row justify-content-between"
            : scheduleTime?.thirtyDays
            ? " d-flex flex-row justify-content-between"
            : scheduleTime?.oneTwentyEightDays
            ? " d-flex flex-row justify-content-between"
            : continuous
            ? " d-flex flex-row justify-content-between"
            : "",
          isLoading: isLoading,
          disable:
            !scheduleTime.sevenDays &&
            !scheduleTime.thirtyDays &&
            !scheduleTime.oneTwentyEightDays &&
            !continuous,
        }}
        onClick={async () => {
          setIsLoading(true);
          const daysToAdd = scheduleTime.sevenDays
            ? 7
            : scheduleTime.thirtyDays
            ? 30
            : scheduleTime.oneTwentyEightDays
            ? 128
            : 0;
          if (
            scheduleTime.sevenDays ||
            scheduleTime.thirtyDays ||
            scheduleTime.oneTwentyEightDays ||
            continuous
          ) {
            let body = {
              ...advertisement,
              subCategory: "",
              time_schedule: { ...scheduleTime, continuously: continuous },
              start_date: moment().format("DD-MM-YYYY"),
              // end_date: new Date(now.getTime() + daysToAdd * 24 * 60 * 60 * 1000),
              end_date: moment().add(daysToAdd, "days").format("DD-MM-YYYY"),
            };
            dispatch(setNewAdvertisement(body));
            try {
              const response = await createNewAdvertisement(body);
              console.log("response", response);
              setIsLoading(false);
              if (response?.data) {
                // dispatch(addList(response?.data));
                Store.addNotification({
                  title: "Success!",
                  message: "Advertisement Create Successfully!",
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  dismiss: { duration: 3000, onScreen: true },
                });
                setIsLoading(false);
              }
              setIsLoading(false);
              dispatch(clearNewAdvertisement());
            } catch (error) {
              console.log("Error ===", error);
              Store.addNotification({
                title: "Error!",
                message: "Advertisement Create Failed!",
                type: "danger",
                insert: "top",
                container: "top-right",
                dismiss: { duration: 3000, onScreen: true },
              });
              setIsLoading(false);
            }
          } else {
            Store.addNotification({
              title: "Error!",
              message: "Campaign Name and Category are required!",
              type: "danger",
              insert: "top",
              container: "top-right",
              dismiss: {
                duration: 3000,
                onScreen: true,
              },
            });
            setIsLoading(false);
          }
        }}
      /> */}
    </>
  );
};

export default withRouter(StartNewAdCampaign);
